import { render, staticRenderFns } from "./building-office.vue?vue&type=template&id=0dcd4420&"
import script from "./building-office.vue?vue&type=script&lang=js&"
export * from "./building-office.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports